const COLOR_KEYS = [
  "primary",
  "success",
  "secondary",
  "danger",
  "warning",
  "info",
  "dark",
  "light",
];

export const PRESETS = {
  padrao: {
    label: "Padrão",
    colors: {
      primary: "#0052B3",
      success: "#0052B3",
      secondary: "#6c757d",
      danger: "#dc3545",
      warning: "#ffc107",
      info: "#17a2b8",
      dark: "#343a40",
      light: "#f8f9fa",
    },
  },
  blackfriday: {
    label: "Black Friday",
    colors: {
      primary: "#000000",
      success: "#e53935",
      secondary: "#424242",
      danger: "#b71c1c",
      warning: "#f57f17",
      info: "#00838f",
      dark: "#000000",
      light: "#f5f5f5",
    },
  },
  natal: {
    label: "Natal",
    colors: {
      primary: "#c62828",
      success: "#2e7d32",
      secondary: "#4e342e",
      danger: "#b71c1c",
      warning: "#f9a825",
      info: "#00695c",
      dark: "#1b1b1b",
      light: "#fafafa",
    },
  },
  verao: {
    label: "Verão",
    colors: {
      primary: "#0277bd",
      success: "#00897b",
      secondary: "#546e7a",
      danger: "#d84315",
      warning: "#ff8f00",
      info: "#00acc1",
      dark: "#263238",
      light: "#e0f7fa",
    },
  },
  halloween: {
    label: "Halloween",
    colors: {
      primary: "#e65100",
      success: "#33691e",
      secondary: "#3e2723",
      danger: "#bf360c",
      warning: "#ff6f00",
      info: "#004d40",
      dark: "#121212",
      light: "#fff3e0",
    },
  },
  pink: {
    label: "Pink",
    colors: {
      primary: "#d81b60",
      success: "#ad1457",
      secondary: "#7b1fa2",
      danger: "#c62828",
      warning: "#f9a825",
      info: "#00838f",
      dark: "#311b92",
      light: "#fce4ec",
    },
  },
};

export function applyThemeVariables(colors) {
  if (!colors) return;

  const root = document.documentElement;

  COLOR_KEYS.forEach((key) => {
    if (colors[key]) {
      root.style.setProperty(`--app-${key}`, colors[key]);
    }
  });
}

export const DEFAULT_COLORS = PRESETS.padrao.colors;
